import styled from 'styled-components'
import { Navbar as Bar } from 'react-bootstrap'
import { device } from 'utils/device'

export const About = styled.div`
  width: 16rem;
  color: white;
  padding: 2rem;
  font-size: 0.8rem;
  opacity: 0;
  position: absolute;
  top: 20rem;
  transition: opacity 0.5s ease-out;

  > div {
    border-bottom: 1px solid ${({ theme }) => theme.palette.primary[1]};
    padding-bottom: 5px;

    > svg {
      font-size: 1rem;
      margin-right: 0.7rem;
    }
  }

  > p {
    margin-left: 1.5rem;
    margin-top: 0.3rem;
    font-size: 0.7rem;

    a {
      color: ${({ theme }) => theme.palette.grayscale[8]};
    }
  }
`

export const Header = styled.div`
  height: 4rem;
`

export const Logo = styled.img`
  width: 6rem;
  margin-left: 1rem;
  margin-right: 1rem;
  opacity: 0;
  position: absolute;
  transition: opacity 0.5s ease-out;
`

export const Toogler = styled.button`
  border: 0;
  margin: 1rem 0;
  right: 0;
  position: absolute;
  background-color: transparent;
  color: white;
  font-size: 1.5rem;
  white-space: nowrap;

  &:focus {
    outline: none;
  }
`

export const NavBar = styled(Bar)`
  background-color: ${({ theme }) => theme.palette.primary[0]};
  justify-content: left;
  position: relative;
  top: 0;
  bottom: 0;
  left: 0;
  min-height: 100vh !important;
  z-index: 100;
  padding: 0 0 4.5rem 0;
  width: 5rem;
  transition: width 1s, opacity 5s ease-out;

  .nav-item {
    width: 100%;

    .nav-link {
      color: white;
      font-size: 0.8rem;

      > .nav-text {
        vertical-align: middle;
        opacity: 0;
        position: absolute;
        transition: opacity 0.9s ease-out;
        white-space: nowrap;
      }

      > svg {
        font-size: 1.3rem;
        margin: 0 0.7rem;
      }
    }

    .badge {
      position: absolute;
      margin-left: -1.2rem !important;
    }

    &.active,
    &:hover {
      background-color: ${({ theme }) => theme.palette.primary[1]};
    }
  }

  &.open {
    width: 17rem;

    ${Logo}, ${About} {
      opacity: 1;
      transition: opacity 2s ease-out;
    }

    .nav-link {
      > .nav-text {
        opacity: 1;
      }
    }

    .badge {
      position: initial;
      margin-left: .5rem !important;
   }
  }

  @media ${device.mobileL} {
    position: fixed;
  }
`
